var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.deviceName)+" "),_c('status-indicator',{staticClass:"ml-5",attrs:{"status":_vm.status,"pulse":"","right":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }